/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// import axios from 'axios';
import $http from '../../plugins/axios';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

export const invokeLearnerForProxyReviewer = async (url: string, data: any) => {
  // let res;
  // eslint-disable-next-line camelcase
  // await $http.post(url, data).then((response) => {
  //   // console.log(response.data.sys_settings);
  //   res = response.data;
  //   return res;
  // });
  const res = await $http.post(url, data);
  return res;
};
export const invokegetSkillProf = async (url: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(url).then((response) => {
    // console.log(response.data.sys_settings);
    res = response.data;
    return res;
  });
  return res;
};
export const invokeGetProxyList = async (url: string, skillId: string) => {
  let res;
  // eslint-disable-next-line camelcase
  await $http.get(`${url}/${skillId}`).then((response) => {
    // console.log(response.data.sys_settings);
    res = response.data.allProxyList;
    return res;
  });
  return res;
};

export const invokeProgramProxies = async (url: string, data: any) => {
  const res = await $http.post(url, data);
  // await $http.post(url, data).then((response) => {
  //   // console.log(response.data.sys_settings);
  //   res = response.data.allProxyList;
  //   return res;
  // });
  return res;
};
export const invokegetAllProxies = async (url: string, data: any) => {
  const res = await $http.post(url, data);
  // await $http.post(url, data).then((response) => {
  //   // console.log(response.data.sys_settings);
  //   res = response.data.allProxyList;
  //   return res;
  // });
  return res;
};

export const invokeAssignProxyToLearners = async (url: string, data: any) => {
  // let res;
  const res = await $http.post(url, data);
  // await $http.post(url, data).then((response) => {
  //   // console.log(response.data.sys_settings);
  //   res = response.data.allProxyList;
  //   return res;
  // });
  return res;
};
